const AGENT_ID = "AWrtwqQeF5dmYQC34W4VW";
const EMBED_SRC = "https://www.chatbase.co/embed.min.js";
const DOMAIN = "www.chatbase.co";

let embedLoaded = false;

interface CookiebotConsent {
  preferences?: boolean;
}

interface CookiebotGlobal {
  consented?: boolean;
  consent?: CookiebotConsent;
}

type ChatbaseFn = ((...args: unknown[]) => unknown) & { q?: unknown[][] };

declare global {
  interface Window {
    Cookiebot?: CookiebotGlobal;
    chatbase?: ChatbaseFn;
  }
}

function preferencesConsentGranted(): boolean {
  const cookiebot = window.Cookiebot;
  if (!cookiebot?.consented) {
    return false;
  }

  return Boolean(cookiebot.consent?.preferences);
}

function bootstrapChatbaseProxy(): void {
  if (window.chatbase?.("getState") === "initialized") {
    return;
  }

  const chatbase: ChatbaseFn = (...args: unknown[]) => {
    if (!chatbase.q) {
      chatbase.q = [];
    }
    chatbase.q.push(args);
  };

  window.chatbase = new Proxy(chatbase, {
    get(target, prop) {
      if (prop === "q") {
        return target.q;
      }

      return (...args: unknown[]) => target(prop as string, ...args);
    }
  });
}

function appendEmbedScript(): void {
  const script = document.createElement("script");
  script.src = EMBED_SRC;
  script.id = AGENT_ID;
  script.setAttribute("domain", DOMAIN);
  document.body.appendChild(script);
}

function loadChatbaseEmbed(): void {
  if (embedLoaded || !preferencesConsentGranted()) {
    return;
  }

  embedLoaded = true;
  bootstrapChatbaseProxy();

  if (document.readyState === "complete") {
    appendEmbedScript();
    return;
  }

  window.addEventListener("load", appendEmbedScript, { once: true });
}

function tryLoadChatbaseEmbed(): void {
  loadChatbaseEmbed();
}

window.addEventListener("CookiebotOnLoad", tryLoadChatbaseEmbed);
window.addEventListener("CookiebotOnAccept", tryLoadChatbaseEmbed);

tryLoadChatbaseEmbed();

export {};
